module.exports = __webpack_public_path__ + "img/logoblue.1fa92f4c.png";